import React, { useState, useEffect, useContext } from 'react';
import { Typography } from '@mui/material';
import { UserContext } from '../../../context/UserContext';
import CommonLayout from '../../../components/CommonLayout';
import './SepsisAppConfig.scss';

const SepsisAppConfig = () => {
    const { user, hospitals, permittedApps } = useContext(UserContext);
    const [selectedHospital, setSelectedHospital] = useState('');
    const [availableHospitals, setAvailableHospitals] = useState([]);

    const APP_NAME = 'SEPSIS_SCREENING';

    useEffect(() => {
        if (hospitals && hospitals.length > 0 && user && permittedApps) {
            let editableHospitals = [];

            if (user.isSuperAdmin) {
                editableHospitals = [...hospitals];
            } else {
                const app = permittedApps.find(a => a.key === APP_NAME);
                if (app) {
                    const permittedHospitalIds = app.admins
                        .filter(admin => (admin.user._id === user._id))
                        .map(admin => admin.hospital._id);
                    editableHospitals = hospitals.filter(h =>
                        permittedHospitalIds.includes(h._id)
                    );
                } else {
                    editableHospitals = [...hospitals];
                }
            }

            let hospitalOptions = [...hospitals];
            if (user.isSuperAdmin) {
                hospitalOptions.push({
                    _id: "apps",
                    nameHebrew: "ברירת מחדל",
                    nameEnglish: "apps"
                });
            }
            setAvailableHospitals(hospitalOptions);

            if (editableHospitals.length === 1) {
                setSelectedHospital(editableHospitals[0].nameEnglish);
            } else if (user.isSuperAdmin && hospitalOptions.length > 0) {
                setSelectedHospital("apps");
            } else if (editableHospitals.length > 0) {
                setSelectedHospital(editableHospitals[0].nameEnglish);
            } else if (hospitalOptions.length > 0) {
                setSelectedHospital(hospitalOptions[0].nameEnglish);
            }
        }
    }, [hospitals, user, permittedApps]);

    return (
        <CommonLayout>
            <div className="sepsis-app-config-container">
                <div className="header-container">
                    <Typography variant="h4" component="h1" className="header-title">
                        ניהול סקר ספסיס
                    </Typography>
                </div>

                <div className="coming-soon-content">
                    <h2>בקרוב...</h2>
                    <p>דף ניהול זה נמצא בפיתוח</p>
                </div>
            </div>
        </CommonLayout>
    );
};

export default SepsisAppConfig;
